import { useEffect } from "react";

import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import EventsData from "./events-data";
import EventsForm from "./events-form";
import ET3PageDiv from "../../../core/et3-page-div";

const MyAuditingMistakes = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_MY_AUDITING_MISTAKES",
      "AUDITOR_MY_AUDITING_MISTAKES"
    );
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("MY_AUDITING_MISTAKES")}
        subTitle={i18n.get("MY_AUDITING_MISTAKES")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <EventsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <EventsData />
    </ET3PageDiv>
  );
});
export default MyAuditingMistakes;
